import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ScrollToTop } from './components/ScrollToTop';
import { HomePage } from './pages/HomePage';
import { HealthBridgePage } from './pages/HealthBridgePage';
import { ProvidersACOsPage } from './pages/ProvidersACOsPage';
import { PayerPage } from './pages/PayerPage';
import { AboutPage } from './pages/AboutPage';
import { InsightsPage } from './pages/InsightsPage';
import { InsightArticlePage } from './pages/InsightArticlePage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsOfServicePage } from './pages/TermsOfServicePage';

export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/healthbridge" element={<HealthBridgePage />} />
        <Route path="/who-we-serve/providers-and-acos" element={<ProvidersACOsPage />} />
        <Route path="/who-we-serve/payers" element={<PayerPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/insights" element={<InsightsPage />} />
        <Route path="/insights/:articleId" element={<InsightArticlePage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms-of-service" element={<TermsOfServicePage />} />
      </Routes>
    </Router>
  );
}
